import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

/**
 * Which stored user types satisfy a route's requiredType.
 *
 * A Company user is a Normal user who also runs a shop: they still have a
 * profile, links and an appearance to edit. Without this, activating the queue
 * — which promotes NU to CU — would lock a merchant out of every screen guarded
 * with requiredType="NU", i.e. most of the app.
 *
 * Admins keep passing everything, as before.
 */
const TYPE_SATISFIES = {
  NU: ["NU", "CU", "AD"],
  CU: ["CU", "AD"],
  AD: ["AD"],
};

export const isTypeAllowed = (userType, requiredType) => {
  if (!requiredType) return true;

  const required = Array.isArray(requiredType) ? requiredType : [requiredType];

  return required.some((type) =>
    (TYPE_SATISFIES[type] ?? [type]).includes(userType),
  );
};

const ProtectedRoute = ({ children, requiredType }) => {
  const userType = JSON.parse(localStorage.getItem("user_type"));
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      const authCheck = JSON.parse(localStorage.getItem("access"));

      if (!authCheck) {
        navigate("/login");
      }
    };

    checkAuth();
    window.addEventListener("storage", checkAuth);

    return () => {
      window.removeEventListener("storage", checkAuth);
    };
  });

  if (!isTypeAllowed(userType, requiredType)) {
    return <Navigate to="/unauthorized" />; // Not authorized
  }

  return children;
};

export default ProtectedRoute;
